import { rem } from '../../libs/polished';

const baseCustom = {
  none: '0px',
  half: '50%',
  full: '9999px',
};

const basePx = {
  x: '4px',
  '2x': '8px',
  '3x': '12px',
  '5x': '20px',
  '8x': '24px',
};

type BasePxKey = keyof typeof basePx;

const baseRem = Object.entries(basePx).reduce(
  (acc, [key, pxVal]) => {
    acc[key as BasePxKey] = rem(pxVal);

    return acc;
  },
  {} as Record<BasePxKey, string>,
);

/**
 * @deprecated please use values from ThemeProvider
 */
const borderRadius = {
  ...baseCustom,
  ...baseRem,
};

export default borderRadius;
